import { render, staticRenderFns } from "./ayuda.vue?vue&type=template&id=ed2b84e2&scoped=true&"
import script from "./ayuda.vue?vue&type=script&lang=js&"
export * from "./ayuda.vue?vue&type=script&lang=js&"
import style0 from "./ayuda.vue?vue&type=style&index=0&id=ed2b84e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2b84e2",
  null
  
)

export default component.exports